<template>
  <v-app class="view">
    <v-dialog
        v-model="EditObjectDialog"
        max-width="300"
        overlay-opacity="0.8"
        persistent
    >
      <form v-if="selectedObject" @submit.prevent="onSubmitObject">
        <v-card class="pa-8">
          <v-head>
            {{ selectedObject.name }}
          </v-head>
          <v-container>
            <v-row>
              <v-col>
                <v-text-field
                    v-model="selectedObject.accommodation_cost"
                    class="dialog-input"
                    label="ค่าที่พัก"
                    outlined
                    placeholder=""
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>


          <v-btn class="close-button float-left" color="gray" fab tile @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn :loading="objectLoading" class="close-button float-right" color="primary" fab tile type="submit">
            <v-icon>mdi-check-bold</v-icon>
          </v-btn>
          <div style="clear: both"></div>
        </v-card>
      </form>
    </v-dialog>

    <Menu :drawerWidth="drawer_width"></Menu>

    <v-content>
      <v-container
          :style="{
                        paddingLeft:(12+drawer_width)+'px',
                     }"
          child-flex
          class="container"

          fluid>


        <v-content
            v-if="progress.status==='NONE'"
        >
          <v-card-title>
            เลือกรถ
            <span class="caption pl-2" @click="selectAllTrucks()">Select all</span>

            <v-spacer></v-spacer>
            <v-btn class="success"
                   @click="progress.status='DONE'">ดูผลคำนวน
            </v-btn>
          </v-card-title>
          <v-card>
            <v-data-table
                v-if="trucks && Array.isArray(trucks)"
                :headers="[
                      { text: 'เลือก', value: 'checked' , width: '80px', fixed: true},
                        { text: 'ทะเบียน', value: 'plate' , width: '120px', fixed: true},
                        { text: 'ชนิด', value: 'type' },
                        { text: 'ชื่อ', value: 'name' },
                        // { text: 'คนขับ', value: 'driver_name' },
                        { text: 'สถานะ', value: 'status' , width: '120px', fixed: true },
                      ]"
                :items="trucks"
                :loading="trucksLoading"
                class="elevation-1 tr-clickable"
                @click:row="viewTruck"
            >
              <template v-slot:item.checked="{ item }">
                <v-checkbox v-model="item.checked" hide-details></v-checkbox>
              </template>
              <template v-slot:item.enabled="{ item }">
                {{ item.enabled ? 'เปิดใช้งาน' : 'ปิด' }}
              </template>
              <template v-slot:item.type="{ item }">
                {{ TruckConst.map(item.type) }}
              </template>
            </v-data-table>

          </v-card>
          <!--          <v-card-actions>-->
          <!--            <v-spacer></v-spacer>-->
          <!--            <v-btn :disabled="trucks.filter(truck => truck.checked).length===0"-->
          <!--                   :loading="isLoadRouteCalculate"-->
          <!--                   class="primary"-->
          <!--                   @click="routeCalculate()">คำนวน-->
          <!--            </v-btn>-->
          <!--          </v-card-actions>-->
        </v-content>

        <v-content
            v-if="progress.status===''||progress.status==='START'||progress.status==='RUN'"
        >
          <div class="text-center">
            <v-card-title>
              กำลังคำนวน {{ progress.text }}
            </v-card-title>
            <v-progress-circular
                v-if="progress.percent>0"
                :rotate="-90"
                :size="100"
                :value="progress.percent"
                :width="15"
                color="primary"

            >
              {{ $helper.number_format(progress.percent, 2, 2) }}%
            </v-progress-circular>
            <v-progress-circular
                v-if="progress.percent===0"
                :size="100"
                :width="15"
                color="primary"
                indeterminate
            ></v-progress-circular>
          </div>
        </v-content>

        <v-content
            v-if="progress.status==='DONE'"
        >
          <v-card-title>
            ผลการคำนวน
            <v-spacer></v-spacer>
            <!--            <v-btn class="primary"-->
            <!--                   @click="progress.status='NONE'">คำนวนใหม่-->
            <!--            </v-btn>-->
          </v-card-title>
          <v-card>
            <v-data-table
                v-if="objects && Array.isArray(objects)"
                :headers="[
                        { text: 'วันที่', value: 'start_at', 'width': '120px' , align:'end'},
                        { text: 'รถ/เส้นทาง', value: 'truck' },
                        // { text: 'เส้นทาง', value: 'transport_route'},
                        // { text: 'km', value: 'total_distance'  , align:'end'},
                        { text: 'มูลค่า', value: 'total_worth'  , align:'end'},
                        { text: 'ค่าใช้จ่าย', value: 'total_cost' ,align:'end'},
                        { text: '%บรรทุก', value: 'percent_load' ,align:'end'},
                        // { text: '%คชจ.', value: 'percent' ,align:'end'},
                        { text: 'กำหนดส่ง', value: 'deliver_date' ,align:'end', 'width': '80px'},
                        { text: 'สถานะ', value: 'status'},
                        { text: 'รายละเอียด', value: 'edit'},
                      ]"
                :items="objects.filter(obj=>obj.status===RouteConst.STATUS_DRAFT)"
                :loading="objectsLoading"

                :search="search"
                class="elevation-1 mb-12 tr-clickable"

                disable-pagination
                hide-default-footer
                @click:row="openRoute"
            >

              <template v-slot:item.start_at="{ item }">
                <span v-if="$helper.date_format_short(item.start_at) == $helper.date_format_short(item.end_at)">
                  {{ $helper.date_format_short(item.start_at) }}
                </span>
                <span v-else>
                  {{ $helper.day_format_short(item.start_at) }}-{{ $helper.date_format_short(item.end_at) }}
                </span>

              </template>
              <template v-slot:item.end_at="{ item }">

              </template>

              <template v-slot:item.truck="{ item }">
                <span class="ellipsis" style="max-height: 42px">
                  <strong>{{
                      item.truck ? item.truck.plate : ''
                    }}</strong>
                  {{ (item.transport_route && item.transport_route.name) || item.cache_provinces }}
                </span>
              </template>
              <template v-slot:item.transport_route="{ item }">

              </template>
              <template v-slot:item.total_distance="{ item }">
                {{
                  $helper.number_format(Math.max(item.total_weight_kg / item.truck.max_weight, item.total_volume_cbm / item.truck.max_cbm) * 100, 2, 2)
                }}

              </template>
              <template v-slot:item.total_worth="{ item }">
                {{ $helper.number_format(item.total_worth, 0, 0) }}
              </template>

              <template v-slot:item.total_cost="{ item }">
                {{ $helper.number_format(item.total_cost, 0, 0) }}
                <span v-if="item.total_cost>0"
                      :class="{
                  'text-green':item.total_cost / item.total_worth<=0.05,
                  'text-red':item.total_cost / item.total_worth>=0.10,
                  'text-yellow':item.total_cost / item.total_worth>0.05 && item.total_cost / item.total_worth<0.10,
                }"

                >({{
                    $helper.number_format(item.total_cost / item.total_worth * 100, 1, 1)
                  }}%)</span>
              </template>
              <template v-slot:item.percent_load="{ item }">
                {{
                  $helper.number_format(
                      Math.max(item.total_weight_kg / item.truck.max_weight * 100,
                          item.total_volume_cbm / item.truck.max_cbm * 100)
                      , 0, 0)
                }}%
              </template>
              <template v-slot:item.percent="{ item }">
                <span v-if="item.total_cost>0">{{
                    $helper.number_format(item.total_cost / item.total_worth * 100, 1, 1)
                  }}%</span>
              </template>

              <template v-slot:item.deliver_date="{ item }">
                <span :class="{'overdue':new Date(item.first_deadline_at) < new Date()}">
                {{ $helper.date_format_short(item.first_deadline_at) }}
                </span>
              </template>

              <template v-slot:item.edit="{ item }">
                <v-btn class="primary" outlined small @click.stop="openRoute(item)">ดู</v-btn>
              </template>

              <template v-slot:item.status="{ item }">
                <v-btn :color="RouteConst.color(item.status)" tile x-small>{{ RouteConst.map(item.status) }}</v-btn>
              </template>

              <template v-slot:item.enabled="{ item }">
                {{ item.enabled ? 'เปิดใช้งาน' : 'ปิด' }}
              </template>
              <template slot="body.append">
                <tr>
                  <th colspan="2" style="text-align: right">Total</th>
                  <th style="text-align: right">{{ $helper.number_format(total_route.total_worth, 0, 0) }}</th>
                  <th style="text-align: right">{{ $helper.number_format(total_route.total_cost, 0, 0) }}
                    <span
                        v-if="total_route.total_cost>0"
                        :class="{
                          'text-green':total_route.total_cost / total_route.total_worth<=0.05,
                          'text-red':total_route.total_cost / total_route.total_worth>=0.10,
                          'text-yellow':total_route.total_cost / total_route.total_worth>0.05 && total_route.total_cost / total_route.total_worth<0.10,
                        }">({{
                        $helper.number_format(total_route.total_cost / total_route.total_worth * 100, 1, 1)
                      }}%)</span>

                  </th>
                  <th style="text-align: right"></th>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-content>
        <v-content>
          <v-card-title>
            ใบทริปที่เลือกไว้
            <v-spacer></v-spacer>
            <!--            <v-btn class="primary"-->
            <!--                   @click="progress.status='NONE'">คำนวนใหม่-->
            <!--            </v-btn>-->
          </v-card-title>
          <v-card>
            <v-data-table
                v-if="objects && Array.isArray(objects)"
                :headers="[
                        { text: 'วันที่', value: 'start_at', 'width': '120px',align:'end'},
                        { text: 'รถ/เส้นทาง', value: 'truck' },
                        // { text: 'เส้นทาง', value: 'transport_route'},
                        // { text: 'km', value: 'total_distance'  , align:'end'},
                        { text: 'มูลค่า', value: 'total_worth'  , align:'end'},
                        { text: 'ค่าใช้จ่าย', value: 'total_cost' ,align:'end'},
                        { text: '%บรรทุก', value: 'percent_load' ,align:'end'},
                        // { text: '%คชจ.', value: 'percent' ,align:'end'},
                        { text: 'กำหนดส่ง', value: 'deliver_date' ,align:'end', 'width': '80px'},
                        { text: 'สถานะ', value: 'status'},
                        { text: 'รายละเอียด', value: 'edit'},
                      ]"
                :items="objects.filter(obj=>obj.status!==RouteConst.STATUS_DRAFT)"
                :loading="objectsLoading"

                :search="search"
                class="elevation-1 mb-12 tr-clickable"

                disable-pagination
                hide-default-footer
                @click:row="openRoute"
            >

              <template v-slot:item.start_at="{ item }">
                <span v-if="$helper.date_format_short(item.start_at) == $helper.date_format_short(item.end_at)">
                  {{ $helper.date_format_short(item.start_at) }}
                </span>
                <span v-else>
                  {{ $helper.day_format_short(item.start_at) }}-{{ $helper.date_format_short(item.end_at) }}
                </span>

              </template>
              <template v-slot:item.end_at="{ item }">

              </template>


              <template v-slot:item.truck="{ item }">
                <span class="ellipsis" style="max-height: 42px">
                    {{item.shipping?item.shipping.code:''}}
                  <strong>{{
                      item.truck ? item.truck.plate : ''
                    }}</strong>
                   {{ (item.transport_route && item.transport_route.name) || item.cache_provinces }}
                </span>
              </template>
              <template v-slot:item.transport_route="{ item }">

              </template>
              <template v-slot:item.total_distance="{ item }">
                {{
                  $helper.number_format(Math.max(item.total_weight_kg / item.truck.max_weight, item.total_volume_cbm / item.truck.max_cbm) * 100, 2, 2)
                }}

              </template>
              <template v-slot:item.total_worth="{ item }">
                {{ $helper.number_format(item.total_worth, 0, 0) }}
              </template>

              <template v-slot:item.total_cost="{ item }">
                {{ $helper.number_format(item.total_cost, 0, 0) }}
                <span v-if="item.total_cost>0"
                      :class="{
                  'text-green':item.total_cost / item.total_worth<=0.05,
                  'text-red':item.total_cost / item.total_worth>=0.10,
                  'text-yellow':item.total_cost / item.total_worth>0.05 && item.total_cost / item.total_worth<0.10,
                }"

                >({{
                    $helper.number_format(item.total_cost / item.total_worth * 100, 1, 1)
                  }}%)</span>
              </template>
              <template v-slot:item.percent_load="{ item }">
                {{item.truck?
                  $helper.number_format(
                      Math.max(item.total_weight_kg / item.truck.max_weight * 100,
                          item.total_volume_cbm / item.truck.max_cbm * 100)
                      , 0, 0):'-'
                }}%
              </template>
              <template v-slot:item.percent="{ item }">
                <span v-if="item.total_cost>0">{{
                    $helper.number_format(item.total_cost / item.total_worth * 100, 1, 1)
                  }}%</span>
              </template>

              <template v-slot:item.deliver_date="{ item }">
                <span :class="{'overdue':new Date(item.first_deadline_at) < new Date()}">
                {{ $helper.date_format_short(item.first_deadline_at) }}
                </span>
              </template>

              <template v-slot:item.edit="{ item }">
                <v-btn class="primary" outlined small @click.stop="openRoute(item)">ดู</v-btn>
              </template>

              <template v-slot:item.status="{ item }">
                <v-btn :color="RouteConst.color(item.status)" tile x-small>{{ RouteConst.map(item.status) }}</v-btn>
              </template>

              <template v-slot:item.enabled="{ item }">
                {{ item.enabled ? 'เปิดใช้งาน' : 'ปิด' }}
              </template>
            </v-data-table>
          </v-card>
        </v-content>
      </v-container>
    </v-content>


  </v-app>
</template>
<style lang="scss" scoped>


.view {
  font-size: 18px;
}

.nav {
  z-index: 1;
}

.container {
  position: relative;
  margin-top: 0;
}

.pad-filter {
  padding: 16px 0 0 24px;
}

.search .v-input__control {
  /*height: 60px;*/
}

.theme--light .list-header-row {
  background: #FFFFFF;
}

.theme--dark .list-header-row {
  background: #000000;
}

.theme--light .primary {
  color: #FFFFFF !important;
}

.overdue {
  color: #CC0000;
}


.text-green {
  color: #009900;
}

.text-yellow {
  color: #999900;
}

.text-red {
  color: #CC0000;
}


</style>
<script lang="ts">

import Menu from '@/components/Logistic/Menu.vue'
import {SimpleResponse} from '@/models/Model'
import {DataArray} from '@/models/Response'
import {Progress, Route, RouteConst} from '@/models/Route'
import {Truck, TruckConst} from '@/models/Truck'
import {Component, Vue} from 'vue-property-decorator'
import LoadingDummy from '../components/LoadingDummy.vue'
import Helper from '../services/Helper.js'

@Component({
  components: {LoadingDummy, Menu},
})
export default class ViewLogisticCalculate extends Vue {

  search = ''

  drawer_ratio = 0.15
  drawer_width = 200

  show_password = false

  objects: Route[] = []

  objectLoading = false
  objectsLoading = false
  EditObjectDialog = false
  selectedObject: Route | null = null

  TruckConst = TruckConst

  trucks: Truck[] = []
  trucksLoading = false
  isLoadRouteCalculate = false
  polling: any = null


  RouteConst = RouteConst
  //
  // newObject() {
  //   this.selectedObject = new Route()
  //   this.selectedObject.datetime_start = '2021-01-01'
  //   this.selectedObject.datetime_end = '2021-12-31'
  //   this.selectedObject.enabled = true
  //   this.EditObjectDialog = true
  //
  // }
  progress: Progress = new Progress()
  total_route = {
    total_worth: 0,
    total_cost: 0,
  }

  async openRoute(object: Route) {
    this.$root.$emit('openRoute', {route: object})
  }

  async viewObject(object: Route) {
    await this.editObject(object)
  }

  async viewTruck(object: Truck) {

  }

  async editObject(object: Route) {
    this.objectLoading = true

    this.EditObjectDialog = true

    if (object.id) {
      this.selectedObject = await (new Route()).load<Route>(object.id)
    }

    this.objectLoading = false

  }

  cancel() {

    this.EditObjectDialog = false
  }

  async onSubmitObject() {
    this.objectLoading = true
    const isNew = this.selectedObject?.id === null

    this.selectedObject = Object.setPrototypeOf(this.selectedObject, Route.prototype)

    if (this.selectedObject) {
      try{
        let object = await this.selectedObject.save<Route>()
        this.$root.$emit('onSuccess', {message: 'บันทึกสำเร็จ'})

        if (isNew) {
          this.objects.push(object)
        } else {
          for (let i in this.objects) {
            if (this.objects[i].id == object.id) {
              this.objects[i] = object
            }
          }
        }
      }catch (e){
        this.$root.$emit('onError', {error: e})
      }
      this.objectLoading = false
    }
    this.selectedObject = null
    this.EditObjectDialog = false
  }

  async deletingObject() {
    this.$confirm('ยืนยันลบข้อมูล?').then(res => {
      if (res) {
        this.deleteObject()
      }
    })

  }

  async routeCalculate() {

    this.progress.status = 'START'
    this.progress.percent = 0
    this.progress.text = 'Starting'

    const url = '/api/route_calculate'

    let truck_ids = this.trucks.filter(truck => truck.checked).map(truck => truck.id)

    if (truck_ids.length == 0) {
      this.$root.$emit('onWarning', {message: 'Please select truck'})
      return
    }

    this.isLoadRouteCalculate = true
    let data = await Helper.post(url, {
      truck_ids: truck_ids,
    }).then<{ response: SimpleResponse }>(({data}) => data.data)
    this.isLoadRouteCalculate = false

    this.startPollData()
  }

  async deleteObject() {
    try {
      if (this.selectedObject == null) return
      this.objectLoading = true

      this.selectedObject = Object.setPrototypeOf(this.selectedObject, Route.prototype)

      const response: SimpleResponse = await this.selectedObject?.delete()

      this.objects = this.objects.filter(object => object.id != this.selectedObject?.id)

      this.selectedObject = null
      this.EditObjectDialog = false

      this.$root.$emit('onSuccess', {message: response.toString()})
    } catch (e) {
      console.log(e)
      this.$root.$emit('onError', {error: e})
    }
    this.objectLoading = false
  }

  async mounted() {
    this.drawer_width = Math.max(80, Math.round(window.innerWidth * this.drawer_ratio))
    console.log('window.innerWidth', window.innerWidth)


    this.refreshTruck().then(() => {
    })

    this.refreshRoute().then(() => {
    })

    this.$root.$on('refreshRoute', this.refreshRoute)
  }

  async refreshRoute() {
    const url = Helper.setting.route.getListAPI

    try {
      this.objectsLoading = true
      let response = await Helper.get(url).then(({data}) => data)

      this.objects = response.data
      this.total_route = response.total
    } catch (e) {
      alert(e)
    }
    this.objectsLoading = false
  }

  async refreshTruck() {
    const url = Helper.setting.truck.getListAPI

    try {
      this.trucksLoading = true
      this.trucks = await Helper.get(url).then<{ data: DataArray }>(({data}) => data.data)

      for (let i in this.trucks) {
        if (this.trucks[i].enabled) {
          this.trucks[i].checked = true
        }
      }

    } catch (e) {
      alert(e)
    }
    this.trucksLoading = false
  }

  whenUpdateStatus(status: string) {
    if (status == 'NONE') {
      clearInterval(this.polling)
      this.polling = null
    } else if (status == 'RUN') {

    } else if (status == 'DONE') {
      clearInterval(this.polling)
      this.polling = null
      this.refreshRoute()
    }
  }

  startPollData() {
    if (this.polling == null) {
      this.pollData()
    }
  }

  pollData() {
    this.polling = setInterval(() => {
      const url = '/api/route_progress'
      Helper.get(url).then<{ data: Progress }>(({data}) => {
        let lastStatus = (this.progress && this.progress.status) ? this.progress.status : 'NONE'
        this.progress = data.progress

        if (lastStatus != this.progress.status || this.polling != null && this.progress.status == 'DONE') {
          this.whenUpdateStatus(this.progress.status)
        }

      })
    }, 2000)
  }

  selectAllTrucks() {
    let allTrucksSelected = true
    // let anyTrucksSelected = false
    // debugger
    for (let i = 0; i < this.trucks.length; i++) {
      allTrucksSelected = allTrucksSelected && (this.trucks[i].checked == true)
      // anyTrucksSelected = anyTrucksSelected || (this.trucks[i].checked == true)
    }
    // debugger
    if (allTrucksSelected) {
      for (let j = 0; j < this.trucks.length; j++) {
        this.trucks[j].checked = false
      }
    } else {
      for (let j = 0; j < this.trucks.length; j++) {
        if (this.trucks[j].enabled) {
          this.trucks[j].checked = true
        }
      }
    }
    this.trucks = [...this.trucks]
  }


  beforeDestroy() {
    clearInterval(this.polling)
    this.polling = null
  }

  created() {
    // this.startPollData()
  }
}
</script>
